module.exports = __webpack_public_path__ + "assets/img/ic-smoke.e54a0569.svg";